(function() {
	'use strict';

	angular.module('importWarehouseApp').config(stateConfig);

	stateConfig.$inject = [ '$stateProvider', '$urlRouterProvider',
			'GLOBAL_URL' ];

	function stateConfig($stateProvider, $urlRouterProvider, GLOBAL_URL) {
		$urlRouterProvider.otherwise("/warehousingTransferHO");
		$stateProvider
				.state(
						'warehousingTransferHO',
						{
							url : '/warehousingTransferHO',
							data : {
								pageTitle : 'Nhập kho điều phối VPC'
							},
							views : {
								'content@' : {
									templateUrl : GLOBAL_URL
											+ 'partial?uri=e-stock/importwarehouse/importtranferho/layouts/ware-house-transfer-ho',
									controller : 'WarehousingTransferHOController',
									controllerAs : 'vm'
								}
							}
						})
				.state(
						'createWarehousingTransferHO',
						{
							url : '/createWarehousingTransferHO/:typeProcess/:stockInId',
							data : {
								pageTitle : 'Nhập kho điều phối VPC'
							},
							params: { 
								stockInId: {squash: true, value: null }
				            },
							views : {
								'content@' : {
									templateUrl : GLOBAL_URL
											+ 'partial?uri=e-stock/importwarehouse/importtranferho/layouts/create-ware-house-transfer-ho',
									controller : 'WarehousingTransferHOController',
									controllerAs : 'vm'
								}
							}
						});
	}
})();
